import React, { useMemo } from 'react';
import { motion } from 'framer-motion';
const REIKI_SYMBOLS = [
// Cho Ku Rei (Simplified path)
'M12 2v16c0 2 2 3 4 3s4-1 4-3-2-3-4-3-4 1-4 3c0 1 .5 2 1.5 2.5M12 6c-3 0-5 2-5 4s2 4 5 4 5-2 5-4-2-4-5-4z',
// Sei He Ki (Simplified path)
'M7 4c0 4 2 6 5 6s5-2 5-6M12 10v10M9 14h6M5 8h14',
// Hon Sha Ze Sho Nen (Abstract representation)
'M12 3v18M8 7h8M7 11h10M9 15h6M10 19h4',
// Dai Ko Myo (Abstract representation)
'M12 2L4 10h16L12 2zM12 10v12M8 14h8M6 18h12'];
export function ReikiBackground() {
  // Generate a fixed set of symbols to avoid re-renders causing jumpy animations
  const symbols = useMemo(() => {
    return Array.from({
      length: 15
    }).map((_, i) => ({
      id: i,
      path: REIKI_SYMBOLS[i % REIKI_SYMBOLS.length],
      left: `${Math.random() * 100}%`,
      size: Math.random() * 40 + 20,
      duration: Math.random() * 20 + 20,
      delay: Math.random() * 20,
      opacity: Math.random() * 0.05 + 0.02
    }));
  }, []);
  return <div className="fixed inset-0 pointer-events-none overflow-hidden z-0" data-id="element-307">
      {symbols.map(symbol => <motion.svg key={symbol.id} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round" style={{
      position: 'absolute',
      left: symbol.left,
      width: symbol.size,
      height: symbol.size,
      color: '#7c3aed',
      opacity: symbol.opacity
    }} initial={{
      y: '110vh',
      rotate: 0
    }} animate={{
      y: '-10vh',
      rotate: 360
    }} transition={{
      duration: symbol.duration,
      repeat: Infinity,
      delay: symbol.delay,
      ease: 'linear'
    }} data-id="element-308">
          <path d={symbol.path} data-id="element-309" />
        </motion.svg>)}
    </div>;
}